import { version } from '../../package.json';
export default version;


//////////////////
// WEBPACK FOOTER
// /Users/qixian.cs/Documents/GitHub/ant-design-pro-site/scaffold/node_modules/_antd@3.9.3@antd/es/version/index.js
// module id = 1011
// module chunks = 0